import CircleSelectModule from './circle-select.module'

export default CircleSelectModule
